type DataLayerPayload = Record<string, unknown>
type DataLayerEntry = DataLayerPayload | unknown[]

declare global {
    interface Window {
        dataLayer?: DataLayerEntry[]
        gtag?: (...args: unknown[]) => void
    }
}

function ensureDataLayer(): DataLayerEntry[] | null {
    if (typeof window === "undefined") return null
    if (!window.dataLayer) window.dataLayer = []
    return window.dataLayer
}

export function pushEvent(eventName: string, payload: DataLayerPayload = {}): void {
    const dl = ensureDataLayer()
    if (!dl) return
    dl.push({event: eventName, ...payload})
}

export function pushEcommerceEvent(eventName: string, payload: DataLayerPayload = {}): void {
    const dl = ensureDataLayer()
    if (!dl) return
    dl.push({ecommerce: null})
    dl.push({event: eventName, ...payload})
}

export function pushUserProperties(props: DataLayerPayload): void {
    const dl = ensureDataLayer()
    if (!dl) return
    dl.push(props)
}

export type {DataLayerPayload}
